export default __webpack_public_path__ + "static/media/twitter_filled.f702c84e.svg";